
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 54 42"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.5 0h-45A4.501 4.501 0 000 4.5V6h54V4.5C54 2.016 51.984 0 49.5 0zM0 37.5C0 39.984 2.016 42 4.5 42h45c2.484 0 4.5-2.016 4.5-4.5V9H0v28.5zm33-21.75c0-.412.337-.75.75-.75h13.5c.413 0 .75.338.75.75v1.5c0 .413-.337.75-.75.75h-13.5a.752.752 0 01-.75-.75v-1.5zm0 6c0-.413.337-.75.75-.75h13.5c.413 0 .75.337.75.75v1.5c0 .413-.337.75-.75.75h-13.5a.752.752 0 01-.75-.75v-1.5zm0 6c0-.413.337-.75.75-.75h13.5c.413 0 .75.337.75.75v1.5c0 .413-.337.75-.75.75h-13.5a.752.752 0 01-.75-.75v-1.5zM16.5 15c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zM6.29 34.144A6.008 6.008 0 0112 30h.769c1.153.478 2.41.75 3.731.75a9.676 9.676 0 003.731-.75H21a6.008 6.008 0 015.71 4.144c.3.928-.488 1.856-1.463 1.856H7.753c-.975 0-1.762-.938-1.462-1.856z","fill":"currentColor"}})])
          )
        }
      }
    